import React, { useMemo } from 'react';
import { DownOutlined } from '@ant-design/icons';
import { Dropdown, Menu } from 'antd';
import { useAuth } from 'auth/Auth0Provider';
import { IUser, logout } from 'auth/Authentication';
import { getAuthConfig } from 'auth/AuthConfig';

export function TopBarAccountSection()
{
	const auth = useAuth();
	// console.log('user', auth.user);

	const { userName, initials } = useMemo(() =>
	{
		let userName = (auth.user as IUser).nickname || '';
		userName = userName?.charAt(0).toUpperCase() + userName?.slice(1);

		let splitted = userName.split(' ');
		let initials = '';
		if (splitted.length > 0) initials = splitted[0].charAt(0);
		if (splitted.length > 1) initials += splitted[1].charAt(0);

		return { userName: userName, initials: initials };
	}, [auth]);

	return (
		<div className="col-auto row" style={{ alignItems: 'center', justifyContent: 'right' }}>
			<span className="topbar-account mgl-auto">
				<span className="topbar-account__avatar txt-center">
					<span className="topbar-account__initials">{initials}</span>
				</span>
				<Dropdown className="mgl-10" overlay={LogoutMenu} trigger={['click']} placement="bottomCenter">
					<a href="/" tabIndex={-1} className="topbar-account__username ant-dropdown-link" onClick={e => e.preventDefault()}>
						{userName} <DownOutlined className="topbar-account__arrow mgl-10" />
					</a>
				</Dropdown>
			</span>
		</div>
	);
};

function LogoutMenu()
{
	return (
		<React.Fragment>
			<Menu className="mgt-5">
				<Menu.Item key="0" onClick={onLogoutClick}>
					Log out
				</Menu.Item>
				{/* <Menu.Divider /> */}
			</Menu>
		</React.Fragment>
	);
};

function onLogoutClick()
{
	const config = getAuthConfig();

	logout({
		client_id: config.client_id,
		returnTo: config.logout_redirect_uri
	});
}

// export default TopBarAccountSection;